import Main from "../views/Main";
import Dashboard from "../views/Dashboard";
import Acesso from "./acesso";
import FormaPgto from "./formaPgto";
import ContaBancaria from "./contaBancaria";
import UnidadeMedida from "./unidadeMedida";
import GrupoItem from "./grupoItem";
import SubGrupoItem from "./subGrupoItem";
import Licenca from "./licenca";
import Item from "./item";
import Empresa from "./empresa";
import Funcionario from "./funcionario";
import Equipamento from "./equipamento";
import EquipamentoMedicao from "./equipamento_medicao";
import Parametros from "./parametros";
import OrdemMedicao from "./ordemMedicao";
import Vendedor from "./vendedor";
import Cliente from "./cliente";
import Fornecedor from "./fornecedor";
import Relatorio from "./relatorio";
import ContasReceber from "./contasreceber";
import Documento from "./documento";
import Cnab from "./cnab";
import RelatorioDocumentos from './relatorio_documentos'

export default {
  path: "/",
  component: Main,
  children: [
    {
      path: "dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        auth: true,
        perms: [],
      },
    },
    Acesso,
    FormaPgto,
    ContaBancaria,
    UnidadeMedida,
    GrupoItem,
    SubGrupoItem,
    Licenca,
    Item,
    Empresa,
    Funcionario,
    Equipamento,
    EquipamentoMedicao,
    Parametros,
    OrdemMedicao,
    Vendedor,
    Cliente,
    Fornecedor,
    Relatorio,
    ContasReceber,
    Documento,
    Cnab,
    RelatorioDocumentos,
    { path: "*", redirect: { name: "dashboard" } },
  ],
};
